export function getUserData() {

  const referrer = document.referrer || null;
  // get Browser
  const userAgent = (() => {
    const nv = navigator.userAgent;
    if (nv.includes("Chrome") && !nv.includes("Edg") && !nv.includes("OPR")) return "Google Chrome";
    if (nv.includes("Edg")) return "Microsoft Edge";
    if (nv.includes("Firefox")) return "Mozilla Firefox";
    if (nv.includes("Safari") && !nv.includes("Chrome")) return "Safari";
    if (nv.includes("OPR") || nv.includes("Opera")) return "Opera";
    if (nv.includes("MSIE") || nv.includes("Trident")) return "Internet Explorer";
    return "Unknown";
  })();

  // get OS
  const os = (() => {
    const userOS = navigator.userAgent;
    if (userOS.indexOf("Windows NT") !== -1) return "Windows";
    if (userOS.indexOf("iPhone") !== -1) return "iPhone";
    if (userOS.indexOf("Android") !== -1) return "Android";
    if (userOS.indexOf("Mac OS X") !== -1) return "Mac OS";
    if (userOS.indexOf("Android") !== -1 && userOS.indexOf("Linux") !== -1) return "Android";
    if (userOS.indexOf("Linux") !== -1) return "Linux";
    return "Unknown";
  })();

  const language = navigator.language || navigator.userLanguage || null;
  const allLanguages = navigator.languages || [language];

  const screen = {
    "width": window.screen.width,
    "height": window.screen.height,
    "pixelDepth": window.screen.pixelDepth,
    "orientation": window.screen.orientation.type,
    "physicalWidth": window.screen.width * window.devicePixelRatio,
    "physicalHeight": window.screen.height * window.devicePixelRatio,
  };
  const screenResolution = `${screen.width}x${screen.height}`;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const now = new Date();

  const date = now.toISOString().split('T')[0]; // YYYY-MM-DD
  const time = now.toTimeString().split(' ')[0]; // HH:MM:SS in 24-hour format


  return {
    userAgent,
    referrer,
    isMobile,
    screenResolution,
    os,
    date,
    time,
    language,
    allLanguages: allLanguages.join(', '),
  }
}
